var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteStoreLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e8e8e8;\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.6,23.3h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.4,0,.4h0s0,0,0,0h.1c0,0,0,0,0,0h0s.1,0,.1,0h0s0,0,0,0v-.4s0,0,0,0M12.9,23.1h0s-.2,0-.2,0h0s0,0,0,0v.4s0,0,0,0h0s.2.1.2.1c0,0,0,0,0,0h0s0-.6,0-.6c0,0,0,0,0,0M12.1,23.1s0,0,0,0h0s0,.6,0,.6c0,0,0,0,0,0h0s.2,0,.2,0h0s0,0,0,0v-.4s0,0,0,0h0s-.2-.1-.2-.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,3c.6,0,1.2.3,1.6.8l2.7,3.6c.1.2.2.4.2.6h0v1c0,1-.4,1.9-1,2.6v7.4c0,1.1-.9,2-2,2H5c-1.1,0-2-.9-2-2v-7.4c-.6-.7-1-1.7-1-2.6v-1h0c0-.2,0-.4.2-.6l2.7-3.6c.4-.5,1-.8,1.6-.8h11ZM15,11.6c-.8.9-1.9,1.4-3,1.4-1.1,0-2.2-.5-3-1.4-.9,1.1-2.4,1.6-3.8,1.3h-.2c0,0,0,6.1,0,6.1h14v-6.1h-.2c-1.4.3-2.8-.2-3.8-1.2h0ZM20,9h-4c0,1.1.9,2,2,2,1.1,0,1.9-.8,2-1.9h0ZM14,9h-4c0,1.1.9,2,2,2,1.1,0,1.9-.8,2-1.9h0ZM8,9h-4c0,1.1.9,2,2,2,1.1,0,1.9-.8,2-1.9h0ZM17.5,5H6.5l-1.5,2h14l-1.5-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteStoreLine);
export default __webpack_public_path__ + "static/media/mingcute--store-line.c3264e228a4d8ff5c6d0ae5e7cacf912.svg";
export { ForwardRef as ReactComponent };